import { useQuery } from 'react-query';

export default (sessionToken, sessionId) => {
  const { data } = useQuery([
    'GET',
    `/apis/v2/direct_video_session_tokens/video_session_end_message`,
    { headers: { 'Adracare-Session-Token': sessionToken, 'Adracare-Session-Id': sessionId } },
  ]);
  return { message: data?.message };
};
